export const Accuracy = "Acc";
export const Damage = "Dmg";
export const Endurance = "End";
export const Recharge = "Rech";
export const Immobilize = "Immob";
